export const getAgentInitials = (agentName: string, maxLength = 2) => {
  let initials = '';

  for (const name of agentName.split(' ')) {
    const char = name.trim().charAt(0).toUpperCase();
    if (char) initials += char;
    if (initials.length === maxLength) return initials;
  }

  return initials;
};
